import { PurchaseRequestStatus, NfaStatus, LfaStatus, RfqStatus, PurchaseOrderStatus, GrnStatus, InvoiceStatus, PaymentStatus } from '@/types/domain';

export const PURCHASE_REQUEST_STATUS_CONFIG: Record<PurchaseRequestStatus, { label: string; variant: 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline' }> = {
  Draft: { label: 'Draft', variant: 'secondary' },
  Submitted: { label: 'Submitted', variant: 'default' },
  UnderReview: { label: 'Under Review', variant: 'warning' },
  PendingApproval: { label: 'Pending Approval', variant: 'warning' },
  ClarificationRequired: { label: 'Clarification Required', variant: 'warning' },
  Approved: { label: 'Approved', variant: 'success' },
  Rejected: { label: 'Rejected', variant: 'destructive' },
  SentBack: { label: 'Sent Back', variant: 'warning' },
  SAPValidation: { label: 'SAP Validation', variant: 'default' },
  SAPPRCreated: { label: 'SAP PR Created', variant: 'success' },
  Processing: { label: 'Processing', variant: 'default' },
  Completed: { label: 'Completed', variant: 'success' },
  Cancelled: { label: 'Cancelled', variant: 'outline' },
};

export const NFA_STATUS_CONFIG: Record<NfaStatus, { label: string; variant: 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline' }> = {
  Draft: { label: 'Draft', variant: 'secondary' },
  Submitted: { label: 'Submitted', variant: 'default' },
  UnderApproval: { label: 'Under Approval', variant: 'warning' },
  Approved: { label: 'Approved', variant: 'success' },
  Rejected: { label: 'Rejected', variant: 'destructive' },
  SentBack: { label: 'Sent Back', variant: 'warning' },
  ClarificationRequested: { label: 'Clarification Requested', variant: 'warning' },
  Cancelled: { label: 'Cancelled', variant: 'outline' },
};

export const LFA_STATUS_CONFIG: Record<LfaStatus, { label: string; variant: 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline' }> = {
  Draft: { label: 'Draft', variant: 'secondary' },
  UnderReview: { label: 'Under Review', variant: 'warning' },
  Awarded: { label: 'Awarded', variant: 'success' },
  Rejected: { label: 'Rejected', variant: 'destructive' },
  Cancelled: { label: 'Cancelled', variant: 'outline' },
};

export const RFQ_STATUS_CONFIG: Record<RfqStatus, { label: string; variant: 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline' }> = {
  Draft: { label: 'Draft', variant: 'secondary' },
  Published: { label: 'Published', variant: 'default' },
  QuotationsReceived: { label: 'Quotations Received', variant: 'warning' },
  Evaluated: { label: 'Evaluated', variant: 'success' },
  Closed: { label: 'Closed', variant: 'secondary' },
  Cancelled: { label: 'Cancelled', variant: 'outline' },
};

export const PO_STATUS_CONFIG: Record<PurchaseOrderStatus, { label: string; variant: 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline' }> = {
  Draft: { label: 'Draft', variant: 'secondary' },
  PendingApproval: { label: 'Pending Approval', variant: 'warning' },
  Approved: { label: 'Approved', variant: 'success' },
  SentToVendor: { label: 'Sent to Vendor', variant: 'default' },
  Acknowledged: { label: 'Acknowledged', variant: 'default' },
  PartiallyDelivered: { label: 'Partially Delivered', variant: 'warning' },
  FullyDelivered: { label: 'Fully Delivered', variant: 'success' },
  Closed: { label: 'Closed', variant: 'secondary' },
  Cancelled: { label: 'Cancelled', variant: 'outline' },
};

export const GRN_STATUS_CONFIG: Record<GrnStatus, { label: string; variant: 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline' }> = {
  Draft: { label: 'Draft', variant: 'secondary' },
  Inspected: { label: 'Inspected', variant: 'warning' },
  Accepted: { label: 'Accepted', variant: 'success' },
  RejectedWithDiscrepancy: { label: 'Discrepancy', variant: 'destructive' },
};

export const INVOICE_STATUS_CONFIG: Record<InvoiceStatus, { label: string; variant: 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline' }> = {
  PendingMatching: { label: 'Pending Matching', variant: 'warning' },
  Matched3Way: { label: '3-Way Matched', variant: 'success' },
  Discrepancy: { label: 'Discrepancy', variant: 'destructive' },
  ApprovedForPayment: { label: 'Approved for Payment', variant: 'default' },
  Paid: { label: 'Paid', variant: 'success' },
};

export const PAYMENT_STATUS_CONFIG: Record<PaymentStatus, { label: string; variant: 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline' }> = {
  Scheduled: { label: 'Scheduled', variant: 'secondary' },
  Processing: { label: 'Processing', variant: 'warning' },
  Completed: { label: 'Completed', variant: 'success' },
  Failed: { label: 'Failed', variant: 'destructive' },
};
